import { useId, FC, ReactNode } from 'react';

export const IdConsumer: FC<{ children: (htmlId: string) => ReactNode }> = ({ children }) => (
    <>{children(useId())}</>
);
